<template>
<div class="chapter">
<div class="inner_page">
<p><a id="cop"></a></p><a id="cop">
<h1 class="copyright-title"><strong>Copyright</strong></h1>
<p class="copyright-space">This book is a work of fiction. Names, characters, places, and incidents are the product of the author’s imagination or are used fictitiously. Any resemblance to actual events, locales, or persons, living or dead, is coincidental.</p>
<p class="copyright-space">Copyright © Kim Holt 1994</p>
<p class="copyright">Cover illustration by Lauren Panepinto. Cover copyright © 2012 by Hachette Book Group, Inc.</p>
<p class="copyright-space">All rights reserved. In accordance with the U.S. Copyright Act of 1976, the scanning, uploading, and electronic sharing of any part of this book without the permission of the publisher is unlawful piracy and theft of the author’s intellectual property. If you would like to use material from the book (other than for review purposes), prior written permission must be obtained by contacting the publisher at permissions@hbgusa.com. Thank you for your support of the author’s rights.</p>
<p class="copyright-space">Orbit</p>
<p class="copyright">Hachette Book Group</p>
<p class="copyright">237 Park Avenue</p>
<p class="copyright">New York, NY 10017</p>
</a><p class="copyright"><a id="cop"></a><a href="http://www.orbitbooks.net" target="_blank">www.orbitbooks.net</a></p>
<p class="copyright-space">Orbit is an imprint of Hachette Book Group. The Orbit name and logo are trademarks of Little, Brown Book Group Limited.</p>
<p class="copyright-space">The publisher is not responsible for websites (or their content) that are not owned by the publisher.</p>
<p class="copyright-space">The Hachette Speakers Bureau provides a wide range of authors for speaking events. To find out more, go to <a href="http://www.hachettespeakersbureau.com" target="_blank">www.hachettespeakersbureau.com</a> or call (866) 376-6591.</p>
<p class="copyright-space">First US e-book edition: September 2012</p>
<p class="copyright-space">ISBN: 978-0-316-23296-8</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tomh_9780748113576_oeb_cop_r1.vue?2183c08e